module.exports = __webpack_public_path__ + "img/gate-rail-horizontal.4f47f2d0.png";